module.exports = __webpack_public_path__ + "static/media/phone-tablet.adba7787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-tablet.png
// module id = 592
// module chunks = 0